<fa-duotone-icon [icon]="['fad', 'hand-point-right']" flip="horizontal"></fa-duotone-icon>
<span>Select at least one item in the sidebar to display {{ itemType }}</span>
